var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { create, setCreateAppStep, setIsContinueDisabled, } from '@project/store/createAppFlow/actions';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { BackButton, CreateAppFooterContainer, NextButton, CreateAppProgressBar, CreateAppFooterButtonContainer, FooterMsgNextContainer, } from '../styles';
import GlobalStyleMessages from './GlobalStyleMessages';
import EnvMessages from './EnvMessages';
import { selectOrganizationId } from '../../../containers/Root/selectors';
import TemplateSelectMessage from './TemplateSelectMessage';
import { AppCreateTypes } from '@project/store/createAppFlow/models';
var CreateAppFooter = function (_a) {
    var next = _a.next, previous = _a.previous, type = _a.type, footerMsg = _a.footerMsg, progress = _a.progress;
    var _b = useSelector(selectAppCreationFlow), name = _b.name, logo = _b.logo, isNameEmpty = _b.isNameEmpty, currentStep = _b.currentStep, data = _b.data, creationType = _b.creationType, newerVersion = _b.newerVersion, legacyVersion = _b.legacyVersion, isContinueDisabled = _b.isContinueDisabled, _c = _b.selectedTemplate, _d = _c.id, id = _d === void 0 ? '' : _d, _e = _c.icon, icon = _e === void 0 ? '' : _e, _f = _c.appId, appId = _f === void 0 ? '' : _f, _g = _c.includeData, includeData = _g === void 0 ? false : _g, version = _c.version, createdTemplateApp = _b.createdTemplateApp, environmentData = _b.environmentData, allRequiredEnvs = _b.allRequiredEnvs, _h = _b.styleName, styleName = _h === void 0 ? 'Theme 1' : _h, _j = _b.styleDescription, styleDescription = _j === void 0 ? 'Default theme' : _j;
    var navigate = useNavigate();
    var selectedOrganizationId = useSelector(selectOrganizationId);
    var dispatch = useDispatch();
    var goTo = function (name, type) {
        dispatch(setCreateAppStep(name, type, next, previous));
    };
    var navigateOrCreateApp = function (next, type) {
        if (type === 'SCRATCH' && currentStep === 'SET_GLOBAL_STYLES_TEXT') {
            dispatch(create(name, selectedOrganizationId, '0', false, data, logo, '0', version === null || version === void 0 ? void 0 : version.minor, newerVersion, AppCreateTypes.COMPLETE, styleName, styleDescription, navigate));
        }
        else if (type === 'TEMPLATE' && currentStep === 'SET_NAME_AND_ICON') {
            if (version !== null && version < newerVersion) {
                dispatch(create(name, selectedOrganizationId, id, includeData, data, logo || icon, appId, version === null || version === void 0 ? void 0 : version.minor, newerVersion, AppCreateTypes.COMPLETE, styleName, styleDescription, navigate));
            }
            else {
                if (type === 'TEMPLATE' && (createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.id) === '') {
                    dispatch(create(name, selectedOrganizationId, id, includeData, data, logo || icon, appId, version === null || version === void 0 ? void 0 : version.minor, newerVersion, AppCreateTypes.PRIMARY, styleName, styleDescription, navigate));
                }
                else {
                    goTo(next, type);
                }
            }
        }
        else {
            if (type === 'TEMPLATE' &&
                (environmentData === null || environmentData === void 0 ? void 0 : environmentData.length) &&
                currentStep === 'SET_ENVIRONMENT_VARIABLES') {
                dispatch(create(name, selectedOrganizationId, id, includeData, data, logo || icon, appId, version === null || version === void 0 ? void 0 : version.minor, newerVersion, AppCreateTypes.ADDITIONAL, styleName, styleDescription, navigate, createdTemplateApp, environmentData));
            }
            else if (type === 'TEMPLATE' &&
                !(environmentData === null || environmentData === void 0 ? void 0 : environmentData.length) &&
                currentStep === 'SET_GLOBAL_STYLES_TEXT') {
                dispatch(create(name, selectedOrganizationId, id, includeData, data, logo || icon, appId, version === null || version === void 0 ? void 0 : version.minor, newerVersion, AppCreateTypes.ADDITIONAL, styleName, styleDescription, navigate, createdTemplateApp));
            }
            else {
                goTo(next, type);
            }
        }
    };
    var isLastStep = function (createType, current) {
        if (createType === 'SCRATCH' && current === 'SET_GLOBAL_STYLES_TEXT') {
            return true;
        }
        else if (createType === 'TEMPLATE') {
            if ((version === null || version === void 0 ? void 0 : version.minor) <= legacyVersion && current === 'SET_NAME_AND_ICON') {
                return true;
            }
            else if (current === 'SET_GLOBAL_STYLES_TEXT' &&
                (environmentData === null || environmentData === void 0 ? void 0 : environmentData.length) === 0) {
                return true;
            }
            else if (current === 'SET_ENVIRONMENT_VARIABLES') {
                return true;
            }
        }
    };
    var navigateOrDisable = function (next, type) {
        if (creationType === 'TEMPLATE' && id === '') {
            dispatch(setIsContinueDisabled(true));
        }
        else {
            navigateOrCreateApp(next, type);
        }
    };
    return (_jsxs(CreateAppFooterContainer, { children: [_jsx(CreateAppProgressBar, { width: progress }), _jsxs(CreateAppFooterButtonContainer, { children: [_jsx(BackButton, __assign({ disabled: creationType === 'TEMPLATE' &&
                            (createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.id) !== '' &&
                            currentStep === 'SET_NAME_AND_ICON', onClick: function () { return goTo(previous, type); } }, { children: "Back" })), _jsxs(FooterMsgNextContainer, { children: [footerMsg, currentStep === 'SET_GLOBAL_STYLES_COLOR' && _jsx(GlobalStyleMessages, {}), currentStep === 'SET_GLOBAL_STYLES_TEXT' && _jsx(GlobalStyleMessages, {}), currentStep === 'SET_ENVIRONMENT_VARIABLES' && _jsx(EnvMessages, {}), currentStep === 'EXPLORE_TEMPLATES' && isContinueDisabled && (_jsx(TemplateSelectMessage, {})), _jsx(NextButton, __assign({ disabled: isNameEmpty ||
                                    (currentStep === 'SET_ENVIRONMENT_VARIABLES' &&
                                        allRequiredEnvs) ||
                                    isContinueDisabled, onClick: function () { return navigateOrDisable(next, type); } }, { children: isLastStep(creationType, currentStep) ? 'Finish' : 'Continue' }))] })] })] }));
};
export default CreateAppFooter;
